export const translations = {
	'Create note': { no: 'Opprett notat' },
	'Edit note': { no: 'Rediger notat' },
};
